import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useColumnDefs as useBetaColumnDefs } from "state/betas/hooks";
import { useColumnDefs as useAnalyticColumnDefs } from "state/analytics/hooks";
import { useColumnDefs as useBookAnalyticColumnDefs } from "state/bookAnalytics/hooks";
import { useColumnDefs as useFactorAttribColumnDefs } from "state/factorAttribution/hooks";
import { useColumnDefs as useRatingColumnDefs } from "state/ratings/hooks";
import { useColumnDefs as useTraceColumnDefs } from "state/traceAnalytics/hooks";
import { useColumnDefs as useSecurityAttribColumnDefs } from "state/securityAttributes/hooks";
import { useColumnDefs as useTrackingErrorColumnDefs } from "state/trackingError/hooks";
import { useColumnDefs as useIssueCountColumnDefs } from "state/issueCount/hooks";
import { useColumnDefs as useIssuerCountColumnDefs } from "state/issuerCount/hooks";
import { useColumnDefs as useScenarioAnalysisColumnDefs } from "state/scenarioAnalysis/hooks";
import { useColumnDefs as useScan2ColumnDefs } from "state/scan2/hooks";
import { setGridInstance } from "state/grid/actions";
import { selectGridInstance } from "state/grid/selector";

export const useColumnDefs = () => {
  const analyticColumnDefs = useAnalyticColumnDefs();
  const bookAnalyticColumnDefs = useBookAnalyticColumnDefs();
  const betasColumnDefs = useBetaColumnDefs();
  const scenarioAnalysisColumnDefs = useScenarioAnalysisColumnDefs();
  const traceAnalyticsColumnDefs = useTraceColumnDefs();
  const faaColumnDefinitions = useFactorAttribColumnDefs();
  const securityAttributesColumnDefs = useSecurityAttribColumnDefs();
  const teColumnDefs = useTrackingErrorColumnDefs();
  const issueCountDefinitions = useIssueCountColumnDefs();
  const issuerCountDefinitions = useIssuerCountColumnDefs();
  const ratingsDefinitions = useRatingColumnDefs();
  const scan2Defs = useScan2ColumnDefs();
  return useMemo(() => {
    return [
      ...analyticColumnDefs,
      ...bookAnalyticColumnDefs,
      ...betasColumnDefs,
      ...scenarioAnalysisColumnDefs,
      ...faaColumnDefinitions,
      ...securityAttributesColumnDefs,
      ...teColumnDefs,
      ...traceAnalyticsColumnDefs,
      ...issueCountDefinitions,
      ...issuerCountDefinitions,
      ...ratingsDefinitions,
      ...scan2Defs,
    ];
  }, [
    analyticColumnDefs,
    bookAnalyticColumnDefs,
    betasColumnDefs,
    scenarioAnalysisColumnDefs,
    faaColumnDefinitions,
    issueCountDefinitions,
    issuerCountDefinitions,
    ratingsDefinitions,
    securityAttributesColumnDefs,
    teColumnDefs,
    traceAnalyticsColumnDefs,
    scan2Defs,
  ]);
};

export const useGridInstance = () => {
  const dispatch = useDispatch();
  return [
    useSelector(selectGridInstance),
    useCallback(
      (gridInstance) => dispatch(setGridInstance(gridInstance)),
      [dispatch]
    ),
  ];
};
